<template>
  <v-container>
    <v-row>
      <v-col cols="12" >
        <v-img
          :src="require('@/assets/banner-finantare.png')"
          class="mx-auto"
          contain
          max-height="100px">
        </v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="text-center">
          CONȚINUTUL MATERIALELOR PUBLICATE PE ACEST SITE NU REPREZINTĂ ÎN MOD OBLIGATORIU POZIȚIA OFICIALĂ A UNIUNII EUROPENE SAU A GUVERNULUI ROMÂNIEI.
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-parallax :src="require('@/assets/hero.jpg')" height="700">
          <v-row align="center">
            <v-col class="text-left" cols="12" lg="8">
              <h1 class="text-lg-h2 text-h4 mb-4 black--text text-center">
                CONCURS PLANURI DE AFACERI
              </h1>
              <h1 class="text-lg-h2 text-h4 mb-4 black--text text-center">
                Proiect I.S.S. – Întreprinderi sociale de succes
              </h1>
              <p class="text-lg-body-1 text-body-2 black--text">
                Proiect cofinanțat din FONDUL SOCIAL EUROPEAN prin Programul Operațional Capital Uman 2014-2020
              </p>
              <p class="text-lg-body-1 text-body-2 black--text">
                Axa prioritară 4 „Incluziunea socială și combaterea sărăciei”
              </p>
              <p class="text-lg-body-1 text-body-2 black--text">
                Schema de ajutor de minimis „Sprijin pentru înființarea de întreprinderi sociale”
              </p>
              <p class="text-lg-body-1 text-body-2 black--text">
                Denumire proiect: „I.S.S - Întreprinderi sociale de succes”, Cod MySMIS 128110
              </p>
              <p class="text-lg-body-1 text-body-2 black--text">
                Pentru informații detaliate despre celelate programe cofinanțate de Uniunea Europeană, vă invităm să vizitați <a href="http://www.fonduri-ue.ro" target="_blank">www.fonduri-ue.ro</a>
              </p>
              <template v-if="!user">
                <v-btn color="primary" :to="{ name: 'Signup' }" :disabled="true">
                  Inscrieți-vă în concurs
                </v-btn>
                <span class="text-lg-caption text-caption black--text"> sau </span>
                <v-btn color="primary" :to="{ name: 'Login' }">
                  Autentificați-vă în platformă
                </v-btn>
              </template>
              <template v-else>
                <v-btn color="primary" :to="{ name: 'Account' }">
                  Accesați contul
                </v-btn>
              </template>
              <p class="text-subtitle-2 mt-8 black--text">
                Prezența noastră în social media
              </p>
              <p>
                <a href="https://www.facebook.com/ISS-Intreprinderi-sociale-de-succes-107731347359838" target="_blank" class="text-decoration-none mr-2">
                  <v-icon color="accent">mdi-facebook</v-icon>
                </a>
              </p>
            </v-col>
          </v-row>
        </v-parallax>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <h5 class="text-h5 text-center my-4">
          Cum particip la concursul de planuri de afaceri?
        </h5>
        <v-stepper v-model="step">
          <v-stepper-header>
            <v-stepper-step step="1" @click="step = 1">
              Pasul 1
              <small>Creati cont</small>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step  step="2" @click="step = 2">
              Pasul 2
              <small>Încărcați documentele aferente Dosarului de concurs</small>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step  step="3" @click="step = 3">
              Pasul 3
              <small>Depuneți Dosarul de concurs</small>
            </v-stepper-step>
          </v-stepper-header>
          <!-- <v-stepper-items>
            <v-stepper-content step="1">
                <v-card flat>
                  <v-card-text class="text-center">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/lqGxj3Esdxc" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </v-card-text>
                </v-card>
            </v-stepper-content>
            <v-stepper-content step="2">
                <v-card flat>
                  <v-card-text class="text-center">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/lqGxj3Esdxc" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </v-card-text>
                </v-card>
            </v-stepper-content>
            <v-stepper-content step="3">
                <v-card flat>
                  <v-card-text class="text-center">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/lqGxj3Esdxc" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </v-card-text>
                </v-card>
            </v-stepper-content>
          </v-stepper-items> -->
        </v-stepper>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" >
        <v-img
          :src="require('@/assets/parteneri.png')"
          class="mx-auto"
          contain
          max-height="60px">
        </v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'LandingComponent',

  data: () => ({
    step: 1
  }),

  computed: {
    user () {
      return this.$store.getters.user
    },
    startSignup () {
      return this.$store.getters.startSignup
    },
    endSignup () {
      return this.$store.getters.endSignup
    }
    // aplicaFlag () {
    //   const now = new Date()
    //   if (this.startSignup) {
    //     const start = new Date(this.startSignup.date)
    //     if (this.endSignup) {
    //       const end = new Date(this.endSignup.date)

    //       if (start <= now && now <= end) {
    //         return {
    //           message: 'Aplica pana pe ' + end.toLocaleString('ro-RO', { year: 'numeric', month: 'long', day: 'numeric' }),
    //           disabled: false
    //         }
    //       }
    //       if (start < now && end < now) {
    //         return {
    //           message: 'Aplicatiile au fost inchise',
    //           disabled: true
    //         }
    //       }
    //       if (start > now) {
    //         return {
    //           message: `Aplica intre ${start.toLocaleString('ro-RO', { year: 'numeric', month: 'long', day: 'numeric' })} si ${end.toLocaleString('ro-RO', { year: 'numeric', month: 'long', day: 'numeric' })}`,
    //           disabled: true
    //         }
    //       }
    //     } else {
    //       if (start <= now) {
    //         return {
    //           message: 'Aplica acum',
    //           disabled: false
    //         }
    //       }
    //       if (start > now) {
    //         return {
    //           message: 'APlica dupa ' + start.toLocaleString('ro-RO', { year: 'numeric', month: 'long', day: 'numeric' }),
    //           disabled: true
    //         }
    //       }
    //     }
    //   } else {
    //     if (this.endSignup) {
    //       const end = new Date(this.endSignup)

    //       if (end <= now) {
    //         return {
    //           message: 'Aplicatiile au fost inchise',
    //           disabled: true
    //         }
    //       }
    //       if (end >= now) {
    //         return {
    //           message: 'Aplica pana pe ' + end.toLocaleString('ro-RO', { year: 'numeric', month: 'long', day: 'numeric' }),
    //           disabled: false
    //         }
    //       }
    //     } else {
    //       return {
    //         message: 'Aplica acum',
    //         disabled: false
    //       }
    //     }
    //   }
    //   return {
    //     message: 'Aplica acum',
    //     disabled: false
    //   }
    // }
  }
}
</script>
